// classes that are reused in the system user block when used as a picker
export const systemUserClasses =
  'pr-2 hover:bg-gray-200 cursor-pointer rounded-md focus-visible:ring-2 focus-visible:ring-gray-800 aria-expanded:bg-gray-200';
